import { render, staticRenderFns } from "./deductionUnderSectionSixteen.vue?vue&type=template&id=f2309d90&scoped=true"
import script from "./deductionUnderSectionSixteen.vue?vue&type=script&lang=js"
export * from "./deductionUnderSectionSixteen.vue?vue&type=script&lang=js"
import style0 from "./deductionUnderSectionSixteen.vue?vue&type=style&index=0&id=f2309d90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2309d90",
  null
  
)

export default component.exports